import Checkbox from '@adsk/alloy-react-checkbox';
import { CellContext, RowData } from '@tanstack/react-table';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import { CellParams, RenderSelectionHeaderProps } from './types';
import { Rfi } from '../../../../sdk';
import { translate } from '../../../../helpers';
import { TEST_KEY_PREFIX } from './constants';

export const renderSelectionHeader =
  ({ setSelection, entities, disabledIds }: RenderSelectionHeaderProps) =>
  ({ table: { getRowModel, getSelectedRowModel } }: CellContext<RowData, never>) => {
    const totalRows = getRowModel().rows.filter(
      (row) => row.getCanSelect() || row.getIsSelected(),
    ).length;
    const selectedRows = getSelectedRowModel().rows.length;
    const isAllSelected = totalRows === selectedRows;
    const isSomeSelected = selectedRows > 0 ? Checkbox.INDETERMINATE : false;
    return (
      <Checkbox
        data-testid={TEST_KEY_PREFIX.TABLE_HEADER_CHECKBOX}
        checked={isAllSelected || isSomeSelected}
        onChange={(checked) => {
          const selectedIds = checked
            ? entities.filter(({ id }: Rfi) => !disabledIds.includes(id))
            : [];
          setSelection(selectedIds, false);
        }}
      />
    );
  };

export const renderSelectionCell = ({
  row: { getIsSomeSelected, getIsSelected, getCanSelect, id },
}: CellContext<RowData, never>) => (
  <Checkbox
    data-testid={`${TEST_KEY_PREFIX.TABLE_CELL_CHECKBOX}${id}`}
    checked={getIsSomeSelected() ? Checkbox.INDETERMINATE : getIsSelected()}
    disabled={!getCanSelect()}
  />
);

export const renderOverFlowTooltipCellData = ({ getValue }: CellParams) => (
  <OverflowTooltip>{getValue() || '-'}</OverflowTooltip>
);

export const renderTranslateOverFlowTooltip = ({ getValue }: CellParams) => {
  const cellData = getValue() as string | string[];
  if (!cellData || !cellData?.length) return '-';
  const value = Array.isArray(cellData)
    ? cellData.map((item) => translate(item)).join(', ')
    : translate(cellData);
  return <OverflowTooltip>{value || '-'}</OverflowTooltip>;
};
